import { PresetVisibility } from '@aibees/shared/definition';

export const config = [
  {
    label: 'All',
    value: PresetVisibility.ALL,
    key: PresetVisibility.ALL,
  },
  {
    label: 'Mine',
    value: PresetVisibility.PRIVATE,
    key: PresetVisibility.PRIVATE,
  },
  {
    label: 'Team',
    value: PresetVisibility.INTERNAL,
    key: PresetVisibility.INTERNAL,
  },
];
